import { createValidator, recoverTelephonePIN } from '../../validation';

import {
  confirmPinCodeValidation,
} from './user-profile-nip-validations';

const userProfilePinValidationFields = {
  confirmPin: [confirmPinCodeValidation],
  newPin: [recoverTelephonePIN],
};

const userProfilePinValidator = createValidator(userProfilePinValidationFields);

const userProfilePinValidation = values => {
  return userProfilePinValidator(values);
};

export default userProfilePinValidation;
